var React = require('react');

function IconBranch (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M678.5 504.1c-66.2 157.2-128.7 245.7-265.4 269-13.6-31.2-39.1-56.1-71.9-69.1V320.9c48.6-21.4 83-68.9 83-124.4 0-73.1-59.7-132.6-133.1-132.6s-133.2 59.5-133.2 132.6c0 55.4 34.5 103 83.1 122.8V704c-50.1 19.8-82.9 67.3-82.9 122.7 0 73.1 59.7 132.6 133.1 132.6 63.3 0 116.4-44.3 129.8-103.4 176.5-27.6 262.6-143.8 344.3-344.4m-531.8-315c0-31.7 25.8-57.5 57.6-57.5s57.6 25.8 57.6 57.5-25.8 57.5-57.6 57.5-57.6-25.8-57.6-57.5zm57.6 687.7c-31.8 0-57.6-25.8-57.6-57.5s25.8-57.5 57.6-57.5 57.6 25.8 57.6 57.5-25.8 57.5-57.6 57.5z","key":0}),React.createElement("path",{"d":"M732.5 251.2c-72.9 0-132 59.1-132 132s59.1 132 132 132 132-59.1 132-132-59-132-132-132zm0 189.6c-31.8 0-57.6-25.8-57.6-57.5s25.8-57.5 57.6-57.5 57.6 25.8 57.6 57.5-25.8 57.5-57.6 57.5z","key":1})]);
}

IconBranch.displayName = "IconBranch";

IconBranch.defaultProps = {"viewBox":"0 0 1024 1024"};

module.exports = IconBranch;

IconBranch.default = IconBranch;
